import ScrollReveal from "@/components/ScrollReveal";
import { Sparkles, TrendingUp, Zap } from "lucide-react";

const PILLARS = [
  {
    icon: Sparkles,
    overline: "Outcomes",
    title: "Improve Outcomes",
    body: "Deliver regenerative therapies that support healing and patient satisfaction — backed by lyophilized amniotic biology.",
  },
  {
    icon: Zap,
    overline: "Efficiency",
    title: "Increase Efficiency",
    body: "Simplify storage, handling, and implementation. Ambient-temperature inventory, no rehydration, no compromise.",
  },
  {
    icon: TrendingUp,
    overline: "Economics",
    title: "Grow Revenue",
    body: "Expand treatment options for ocular surface disease while improving practice economics and patient retention.",
  },
];

export default function WhyRenVia() {
  return (
    <section data-testid="why-renvia" className="relative bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
          <ScrollReveal className="lg:col-span-7">
            <div className="text-xs tracking-[0.22em] uppercase text-teal font-semibold">
              Why RenVia
            </div>
            <h2 className="mt-5 font-display text-4xl md:text-5xl text-slate1 leading-tight max-w-2xl">
              A premium partner for the next era of ocular surface care.
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={120} className="lg:col-span-5">
            <p className="text-lg text-slate1/70 leading-relaxed">
              RenVia exists to bring regenerative innovation into the hands of eye care
              professionals — with clinical credibility, operational simplicity, and
              partnership that scales with your practice.
            </p>
          </ScrollReveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <ScrollReveal key={p.title} delay={i * 120}>
                <div
                  data-testid={`pillar-${p.overline.toLowerCase()}`}
                  className="group relative h-full rounded-3xl bg-cloud border border-transparent hover:border-teal/30 p-8 md:p-10 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_28px_60px_-20px_rgba(0,45,114,0.18)]"
                >
                  <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-teal to-navy flex items-center justify-center text-white mb-8 shadow-[0_12px_24px_-8px_rgba(21,184,184,0.45)]">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="text-[10px] tracking-[0.24em] uppercase text-teal font-bold mb-3">
                    {p.overline}
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl text-slate1 font-medium mb-4">
                    {p.title}
                  </h3>
                  <p className="text-slate1/65 leading-relaxed">{p.body}</p>
                  <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="text-teal text-sm font-semibold inline-flex items-center gap-2">
                      Learn more <span aria-hidden>→</span>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
